module.exports = __webpack_public_path__ + "img/outside-view.8865d5c7.jpg";